var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { executeOrderApICDSLMP, getPledgeRequest, getUnpledgeRequest, saveUnpledgeRequest, } from "src/apis/dashboard";
import { openPledgeUnpledgeModal, closePledgeUnpledgeModal, } from "src/redux/reducers/modals";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getpledgeDummyData } from "src/apis/mock/data/get-pledge-data";
import { getunpledgeDummyData } from "src/apis/mock/data/get-unpledge-data";
import { PLEDGE, UNPLEDGE } from "src/utils/constant";
import Modal from "react-modal";
import styles from "src/components/footer/footerHoldings/holdingsDashboard.module.scss";
import Loader from "src/components/loader/loader";
import Pledge from "src/components/footer/footerHoldings/pledge";
import Unpledge from "src/components/footer/footerHoldings/unpledge";
import { ToastUtils } from "src/utils/toast-utils";
import { getDummySubmitPledgeResponse } from "src/apis/mock/data/get-submit-pledge-request";
import { redirectToCDSL } from "src/utils/methods";
const { REACT_APP_ENV } = process.env;
const PledgeUnpledgePopup = () => {
    const [pledgeLoading, setPledgeLoading] = useState(true);
    const [unPledgeLoading, setUnPledgeLoading] = useState(true);
    const [disabledSubmitRequest, setdisabledSubmitRequest] = useState(false);
    const [PledgeData, setPledgeData] = useState([]);
    const [unPledgeData, setUnPledgeData] = useState([]);
    const [DisabledSumbit, setDisabledSumbit] = useState(true);
    //   const [holdingmodal, setHoldingmodal] = useState(false);
    const [tab, setTab] = useState("pledge");
    const dispatch = useAppDispatch();
    const isPledgeUnPldge = useAppSelector((state) => {
        return state.modals.pledgeunpledgeModal;
    });
    useEffect(() => {
        fetchPledge();
    }, []);
    useEffect(() => {
        fetchUnPledge();
    }, []);
    const fetchPledge = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setPledgeLoading(true);
            const pledgeRequestData = REACT_APP_ENV == "development"
                ? { data: getpledgeDummyData() }
                : yield getPledgeRequest();
            if (pledgeRequestData.data.body.Data.length > 0) {
                setdisabledSubmitRequest(true);
                const arr = pledgeRequestData.data.body.Data;
                arr.forEach((singleElement) => {
                    singleElement.checkbox = false;
                    singleElement.lableCheck = false;
                    singleElement.customQty = singleElement.DPQty;
                });
                setPledgeData(arr);
            }
            else {
                setPledgeData([]);
                setdisabledSubmitRequest(false);
                setPledgeLoading(false);
            }
            // setPledgeData(pledgeRequestData.data.body.Data);
        }
        catch (error) {
            //setHoldings([]);
            console.error(error);
        }
        finally {
            setPledgeLoading(false);
        }
    });
    const fetchUnPledge = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setUnPledgeLoading(true);
            const pledgeRequestData = REACT_APP_ENV == "development"
                ? { data: getunpledgeDummyData() }
                : yield getUnpledgeRequest();
            if (pledgeRequestData.data.body.Data.length > 0) {
                setdisabledSubmitRequest(true);
                const arr = pledgeRequestData.data.body.Data;
                arr.forEach((singleElement) => {
                    singleElement.unPledgeMargin = 0;
                });
                setUnPledgeData(arr);
                // setUnPledgeLoading(false);
            }
            else {
                setUnPledgeData([]);
                setdisabledSubmitRequest(false);
                setUnPledgeLoading(false);
            }
        }
        catch (error) {
            setUnPledgeData([]);
            console.error(error);
        }
        finally {
            setUnPledgeLoading(false);
        }
    });
    const submitPledgeRequest = (selectedPledgeData) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const submitPledgeResponse = REACT_APP_ENV == "development"
                ? { data: getDummySubmitPledgeResponse() }
                : yield executeOrderApICDSLMP(selectedPledgeData);
            if (submitPledgeResponse.data.body !== null) {
                if (submitPledgeResponse.data.body.Status === 0) {
                    const data = submitPledgeResponse.data.body;
                    redirectToCDSL(data.posturl, data.dpid + "", data.reqid, data.pledgedtls, true);
                }
                else {
                    ToastUtils.error(submitPledgeResponse.data.body.Message);
                    //   setHoldingmodal(false);
                    dispatch(closePledgeUnpledgeModal());
                }
            }
        }
        catch (error) {
            console.error(error);
        }
    });
    const submitunPledgeRequest = (selecpledge) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const submitPledgeResponse = REACT_APP_ENV == "development"
                ? { data: getDummySubmitPledgeResponse() }
                : yield saveUnpledgeRequest(selecpledge);
            const data = submitPledgeResponse.data.body;
            if (data.Status === 0) {
                ToastUtils.success("Unpledge request received");
            }
            else {
                ToastUtils.error(data.Data[0].Reason);
            }
            //   setHoldingmodal(false);
            dispatch(closePledgeUnpledgeModal());
        }
        catch (error) {
            console.error(error);
        }
    });
    const handleSubmit = () => {
        if (tab === PLEDGE) {
            if (PledgeData.length > 0) {
                const pledgeData = [];
                PledgeData.map((item) => {
                    const pledgeForm = {};
                    if (item.checkbox) {
                        pledgeForm["ISIN"] = item.ISINCode;
                        pledgeForm["Quantity"] = item.customQty;
                        pledgeData.push(pledgeForm);
                    }
                });
                submitPledgeRequest(pledgeData);
            }
        }
        if (tab === UNPLEDGE) {
            const unpledgeData = [];
            unPledgeData.forEach((element) => {
                if (element.unPledgeMargin > 0) {
                    const pledgeForm = {};
                    pledgeForm["ISINCode"] = element.ISINCode;
                    pledgeForm["Qty"] = element.unPledgeMargin;
                    unpledgeData.push(pledgeForm);
                }
            });
            submitunPledgeRequest(unpledgeData);
        }
        setDisabledSumbit(true);
    };
    const openHoldingModal = (tabName) => {
        if (tabName === "pledge") {
            setTab("pledge");
            //   setHoldingmodal(true);
            dispatch(openPledgeUnpledgeModal());
        }
        else if (tabName === "unpledge") {
            setTab("unpledge");
            //   setHoldingmodal(true);
            dispatch(openPledgeUnpledgeModal());
        }
    };
    const toggleConfirmDeleteModal = (newValue) => {
        // setIsOpen(newValue);
        if (newValue) {
            dispatch(openPledgeUnpledgeModal());
        }
        else {
            dispatch(closePledgeUnpledgeModal());
        }
    };
    const getPledgeData = (pledge) => {
        if (pledge.length > 0) {
            setPledgeData(pledge);
            const disabledSubmit = pledge.every((item) => {
                return item.customQty > item.DPQty;
            });
            if (disabledSubmit) {
                setDisabledSumbit(disabledSubmit);
            }
            else {
                setDisabledSumbit(disabledSubmit);
            }
        }
    };
    const getUnPledgeData = (unPledge) => {
        setUnPledgeData(unPledge);
        if (unPledge.length > 0) {
            const anysubmit = unPledge.every((item) => {
                return item.UnPledgeQty >= item.unPledgeMargin;
            });
            const disabledSubmit = unPledge.some((item) => {
                return item.unPledgeMargin > 0;
            });
            if (disabledSubmit && anysubmit) {
                setDisabledSumbit(false);
            }
            else {
                setDisabledSumbit(true);
            }
        }
    };
    const finalCheck = (lable) => {
        const pledge = [...PledgeData];
        const disabledSubmit = pledge.every((item) => {
            return item.checkbox === false;
        });
        const anysubmit = pledge.some((item) => {
            if (item.checkbox) {
                return item.customQty === 0 || item.customQty > item.DPQty;
            }
        });
        if (!anysubmit && !disabledSubmit && lable) {
            setDisabledSumbit(false);
        }
        else {
            setDisabledSumbit(true);
        }
    };
    return (_jsx(_Fragment, { children: isPledgeUnPldge && (_jsxs(Modal, Object.assign({ isOpen: isPledgeUnPldge, onRequestClose: () => toggleConfirmDeleteModal(false), className: `${styles.myCommonModal} w-75 holdingpopup`, overlayClassName: styles.myCommonOverlay }, { children: [" ", _jsxs("div", Object.assign({ className: `${styles.modalHeaderPart} mb-3` }, { children: [_jsx("div", Object.assign({ className: "pledge-un-tab" }, { children: _jsxs("ul", { children: [_jsx("li", Object.assign({ onClick: () => {
                                            fetchPledge();
                                            setDisabledSumbit(true);
                                            openHoldingModal(PLEDGE);
                                        } }, { children: _jsx("a", Object.assign({ className: tab === PLEDGE ? "active" : "" }, { children: "Pledge" })) })), _jsx("li", Object.assign({ onClick: () => {
                                            setPledgeData([]);
                                            fetchUnPledge();
                                            setDisabledSumbit(true);
                                            openHoldingModal(UNPLEDGE);
                                        } }, { children: _jsx("a", Object.assign({ className: tab === UNPLEDGE ? "active" : "" }, { children: "Unpledge" })) }))] }) })), _jsx("span", { className: styles.closeModal, onClick: () => toggleConfirmDeleteModal(false) })] })), tab === PLEDGE &&
                    (pledgeLoading ? (_jsx(Loader, {})) : (_jsx(Pledge, { onRequestClose: () => toggleConfirmDeleteModal(false), pledgeData: PledgeData, setSubmit: getPledgeData, finalCheck: finalCheck }))), tab === UNPLEDGE &&
                    (unPledgeLoading ? (_jsx(Loader, {})) : (_jsx(Unpledge, { onRequestClose: () => toggleConfirmDeleteModal(false), unpledgeData: unPledgeData, setsubmit: getUnPledgeData }))), disabledSubmitRequest && (_jsx("div", Object.assign({ className: "bottom-btn text-center" }, { children: _jsx("button", Object.assign({ className: "btnType1", disabled: DisabledSumbit, onClick: () => {
                            handleSubmit();
                        } }, { children: "Submit Request" })) })))] }))) }));
};
export default PledgeUnpledgePopup;
